import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Payout from "../components/pressroomLayout"
import PropTypes from "prop-types"

 const IntheNews = ({ data }) => {

  return (
    <Payout>
      {
        data.allYoutubeVideo.edges.map(({ node }) => {

          let youtubeUrl = 'https://www.youtube.com/embed/' + node.videoId + '?rel=0'

          return (
            <div className="col-12 p-0 m-0" key={node.id}>
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" allowfullscreen="true" src={youtubeUrl} title={node.title}></iframe>
              </div>
              <a href={youtubeUrl} target="_blank" className="text-decoration-none" rel="noopener noreferrer">
               <h4 className="text-size-16 text-body" dangerouslySetInnerHTML={{ __html: node.title }} />
              </a>
              <div className="text-muted d-block mb-4">{node.publishedAt}</div>
            </div>
          )
        })
      }
    </Payout>
  )
}
export default props => (
  <StaticQuery
    query={graphql`
      query {
        allYoutubeVideo(
          sort: {
            order: DESC, 
            fields: publishedAt},
            limit: 10)
          {
          edges {
            node {
              id
              title
              videoId
              publishedAt(formatString: "MMMM DD, YYYY")
            }
          }
        }
      }
    `}
    render={data => <IntheNews data={data} {...props} />}
  />
)

IntheNews.propTypes = {
    data: PropTypes.shape({
      allYoutubeVideo: PropTypes.shape({
        edges: PropTypes.shape({
          node: PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            videoId: PropTypes.string.isRequired,
            publishedAt: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}